<template>
  <div class="responsive-page" ref="scrollablePageMobile" @scroll="onScroll">
    <div class="page-wrapper">
      <div class="page-and-header" ref="scrollablePage" @scroll="onScroll">
        <div v-show="appLoading" class="loader-container">
          <loader />
        </div>

        <router-view v-show="!appLoading"/>
        <bottom-corner-popup/>
        <cx-message-toast />
        <ai-chat-csat-host />
      </div>
      <div class="footer-wrapper">
        <copyright-footer/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventBus from '@/event-bus/event-bus';
import BaseUI from '@riseupil/base-ui';
import BottomCornerPopup from '@/bottom-corner-popup/BottomCornerPopup';
import CxMessageToast from '@/chat-boot/CxMessageToast.vue';
import AiChatCsatHost from '@/chat-boot/AiChatCsatHost.vue';
import MobileMessagesUtils from '@/utils/mobileMessagesUtils.js';
import CopyrightFooter from '../../base-components/CopyrightFooter.vue';
import Loader from '../../base-components/Loader.vue';

export default {
  name: 'ResponsivePage',
  components: {
    CxMessageToast,
    AiChatCsatHost,
    BottomCornerPopup,
    CopyrightFooter,
    Loader,
  },

  created() {
    this.onResize();
    EventBus.$on('reset-scroll', this.resetScroll);
    EventBus.$on('scroll-bottom', this.scrollBottom);
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    MobileMessagesUtils.dispatchMessageToMobile(MobileMessagesUtils.MOBILE_MESSAGES_NAME.PAGE_MOUNTED, {});
  },
  beforeDestroy() {
    EventBus.$off('reset-scroll', this.resetScroll);
    EventBus.$off('scroll-bottom', this.scrollBottom);
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    ...mapGetters('loader', ['appLoading']),
  },
  methods: {
    onResize() {
      // This function handles mobile viewport height calculations with a retry mechanism
      // Flutter WebViews sometimes initially return 0 for window.innerHeight on page load
      const maxRetries = 50;
      const setVh = (retries = 0) => {
        const { innerHeight } = window;
        if (!innerHeight && retries < maxRetries) {
          console.log('innerHeight', { innerHeight, retries });
          // Wait 300ms and try again, incrementing retry counter
          setTimeout(() => setVh(retries + 1), 300);
          return;
        }
        // Calculate vh unit (1% of viewport height) and set CSS variable
        if (innerHeight) {
          const vh = (innerHeight || 0) * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
      };
      setVh();
    },
    resetScroll() {
      this.$refs.scrollablePage.scrollTop = 0;
      this.$refs.scrollablePageMobile.scrollTop = 0;
    },
    scrollBottom() {
      this.$refs.scrollablePage.scrollTop = 10000;
      this.$refs.scrollablePageMobile.scrollTop = 10000;
    },
    onScroll(e) {
      BaseUI.BottomTabsPageBus.$emit('scroll', e.target);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '../../scss/mixins';

.responsive-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  scroll-behavior: smooth;
  position: fixed;
  .page-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    .page-and-header {
      width: 100%;
      height: 100%;
      .loader-container {
        height: 100%;
      }
    }
    .footer-wrapper {
      display: none;
    }
  }
}
@media (min-width: 460px) {
  .responsive-page {
    background-color: $riseup_beige;
    .page-wrapper {
      width: 400px;
      display: flex;
      align-items: center;
      margin: calc(100vh*0.05) 0;
      .page-and-header {
        margin-bottom: 20px;
        background-color: $riseup_white;
        min-height: inherit;
        height: calc(100vh - 100vh*0.1 - 35px - 20px);
        border-radius: 3px;
        box-shadow: 0 2px 5px 0 rgba(166, 166, 166, 0.5);
        border: solid 1px #e7e7e7;
        overflow: scroll;
        overflow-x: hidden;
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
      }
      ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }
      .footer-wrapper {
        width: 100%;
        visibility: visible;
        display: inline-block;
        height: 35px;
      }
    }
  }
}
</style>
